// src/pages/admin/VendorsList.js
import React from 'react';
import { Card, List, Avatar, Button } from 'antd';
import { ShopOutlined } from '@ant-design/icons';

const VendorsList = ({ vendors, handleApproveVendor, navigate }) => (
  <Card title="Recent Vendors" bordered={false} style={{ marginTop: 16 }}>
    <List
      itemLayout={window.innerWidth < 768 ? 'vertical' : 'horizontal'}
      dataSource={vendors.slice(0, 5)}
      renderItem={(item) => (
        <List.Item
          actions={[
            <Button type="link" onClick={() => navigate(`/admin/vendors/edit/${item.id}`)}>Edit</Button>,
            <Button
              type="link"
              danger={item.status === 'Pending'}
              onClick={() => item.status === 'Pending' ? handleApproveVendor(item.id) : navigate(`/admin/vendors/${item.id}`)}
            >
              {item.status === 'Pending' ? 'Approve' : 'View'}
            </Button>,
          ]}
        >
          <List.Item.Meta
            avatar={<Avatar icon={<ShopOutlined />} />}
            title={item.name}
            description={`Products: ${item.products} | Status: ${item.status} | Revenue: $${item.revenue}`}
          />
        </List.Item>
      )}
    />
  </Card>
);

export default VendorsList;